import apiConfig from '../apiConfig';
import { getAxiosInstance } from '../../utils/axiosApi';

const axiosInstance = getAxiosInstance({
  baseUrl: apiConfig.KCMS_API,
});
const downloadDocumentByID = async (ContentDocumentId) => {
  try {
    const response = await axiosInstance.get(`/Integration/id/${ContentDocumentId}/Content`, {
      responseType: 'blob',
    });
    return response.data;
  } catch (error) {
    throw new Error('Thumbnail');
  }
};

const autoCompleteDocuments = async (documentName, contentID, currentPage = 1, pageSize = 20) => {
  try {
    const response = await axiosInstance.get('/Integration/ContentDocument/AutoComplete', {
      params: {
        DocumentName: documentName,
        contentID,
        currentPage,
        pageSize,
      },
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching auto complete documents:', error);
    throw error;
  }
};
const searchDocumentFiles = async (ContentID) => {
  try {
    const response = await axiosInstance.get(`/Integration/ContentID/${ContentID}/All`);
    return response.data;
  } catch (error) {
    throw new Error('Attachment');
  }
};

const uploadAttachments = async (attachmentPayload) => {
  try {
    const response = await axiosInstance.post('/Integration/Upload/Attachment', attachmentPayload);
    return response.data;
  } catch (error) {
    if (error?.response?.status >= 300 && error?.response?.data) {
      throw new Error(error?.response?.data);
    } else {
      throw new Error('Error uploading attachments');
    }
  }
};
const uploadShareableAttachment = async (shareableAttachmentPayload) => {
  try {
    const response = await axiosInstance.post('/Integration/Upload/SharableAttachment', shareableAttachmentPayload);
    return response.data;
  } catch (error) {
    if (error?.response?.status >= 300 && error?.response?.data) {
      throw new Error(error?.response?.data);
    } else {
      throw new Error('Error uploading shareable attachments');
    }
  }
};
const ContentDocumentApi = {
  downloadDocumentByID,
  autoCompleteDocuments,
  searchDocumentFiles,
  uploadAttachments,
  uploadShareableAttachment,
};

export default ContentDocumentApi;
